import { cn } from '@gettactic/helpers';
import React from 'react';
import {
  useColumnWidth,
  columnXSpacing
} from '../../contexts/ColumnWidthContext';

export const WeeklyDataLayout = ({
  chart,
  legend,
  table,
  daysCount
}: {
  chart: React.ReactNode;
  legend: React.ReactNode;
  table: React.ReactNode;
  daysCount: number;
}) => {
  const { nameColumnWidth, dayColumnWidth, totalWidth, isOverflowing } =
    useColumnWidth();

  // If no valid daysCount, don't render
  if (!daysCount) {
    return null;
  }

  return (
    <div className={cn('space-y-4 ', isOverflowing ? 'w-full' : '')}>
      <WeeklyDataGridWrapper
        nameColumnWidth={nameColumnWidth}
        daysCount={daysCount}
      >
        {legend}

        <div
          className="col-span-full col-start-2"
          style={{
            gridColumn: `2 / span ${daysCount}`,
            width: `${dayColumnWidth * daysCount + columnXSpacing * (daysCount - 1)}px`,
            maxWidth: '100%'
          }}
        >
          {chart}
        </div>
      </WeeklyDataGridWrapper>
      {table}
    </div>
  );
};

export const WeeklyDataGridWrapper = ({
  children,
  nameColumnWidth,
  daysCount,
  className
}: {
  children: React.ReactNode;
  nameColumnWidth: number;
  daysCount: number;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'flex w-full flex-col gap-0 text-center md:grid',
        className
      )}
      style={{
        gridTemplateColumns: `${nameColumnWidth}px repeat(${daysCount}, minmax(0, 1fr))`,
        width: '100%',
        alignItems: 'stretch',
        rowGap: '2px',
        columnGap: `${columnXSpacing}px`
      }}
    >
      {children}
    </div>
  );
};
